// extracted by mini-css-extract-plugin
module.exports = {"root":"InputBlock_root__1tHG6","have-mask":"InputBlock_have-mask__B6P5r","mask":"InputBlock_mask__PeDMX"};